export default __webpack_public_path__ + "static/media/Banner-image.b42d3f0c.png";